var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"itemsRef",staticClass:"items"},[(_vm.machineTypes)?_c('div',_vm._l((_vm.machineTypes),function(machineType,index){return _c('div',{key:index + _vm.genId()},[_c('machine-type-item',{attrs:{"machineIndex":Number(index),"machineType":machineType}})],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }